<template>
  <div>
    <div class="wizardWrapper">
      <div class="tab" v-if="activeTab === 1">
        <EnquireDetails @nextClick="onNextAction" @backClick="onBackAction" />
      </div>

      <div class="tab" v-if="activeTab === 2">
        <ViewAppointment @nextClick="onNextAction" @backClick="onBackAction" />
      </div>

      <div class="tab" v-if="activeTab === 3">
        <RescheduleAppointment @nextClick="onNextAction" @backClick="onBackAction" />
      </div>

      <div class="tab" v-if="activeTab === 4">
        <RescheduleAppointmentAcknowledgement @nextClick="onNextAction" @backClick="onBackAction" />
      </div>
    </div>
  </div>
</template>

<script setup>
import { ref, onBeforeMount } from 'vue'
import { useStore } from 'vuex'

import EnquireDetails from './enquire-appointment-details.vue'
import ViewAppointment from './view-appointment-details.vue'
import RescheduleAppointment from './reschedule-appointment.vue'
import RescheduleAppointmentAcknowledgement from './reschedule-appointment-acknowledgement.vue'

const store = useStore()
const activeTab = ref(1)

onBeforeMount(() => {
  activeTab.value = store.getters.getActiveTab
})

function onNextAction() {
  if (activeTab.value < 5) {
    activeTab.value++
    store.dispatch('setActiveTab', activeTab.value)
  }
}

function onBackAction() {
  if (activeTab.value > 1) {
    activeTab.value--
    store.dispatch('setActiveTab', activeTab.value)
  }
}
</script>
